import React from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AddToMyContentDialog = ({
  open,
  sentenceText,
  currentContent,
  isMyContent,
  isMyContentEmpty,
  onCancel,
  onAdd,
}) => {
  const showLocationActions = isMyContent && !isMyContentEmpty;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          backgroundColor: 'seashell',
          borderRadius: 2,
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Adding "{sentenceText}" to MyContent
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isMyContentEmpty
            ? 'MyContent is empty. This sentence will be added as the first sentence.'
            : isMyContent
              ? 'Choose where this sentence should be added in MyContent.'
              : `You are currently working with predefined content "${currentContent}". This sentence will be added to the top of MyContent.`
            }
        </DialogContentText>
        {showLocationActions && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 0.75 }}>
              Insert location
            </Typography>
            <ButtonGroup
              fullWidth
              size="small"
              variant="outlined"
              sx={{
                gap: 1,
                boxShadow: 'none',
                '& .MuiButtonGroup-grouped': {
                  borderRadius: 5,
                  borderLeftColor: 'primary.main',
                  textTransform: 'none',
                  minHeight: 36,
                  '&:not(:last-of-type)': {
                    borderRightColor: 'primary.main',
                  },
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    borderColor: 'primary.main',
                    color: 'primary.contrastText',
                    boxShadow: 2,
                    transform: 'translateY(-1px)',
                  },
                },
              }}
            >
              <Button onClick={() => onAdd('top')}>Top</Button>
              <Button onClick={() => onAdd('above')}>Above</Button>
              <Button onClick={() => onAdd('below')}>Below</Button>
            </ButtonGroup>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        {!showLocationActions && (
          <Button onClick={() => onAdd('top')} color="primary" variant="contained">
            Add
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AddToMyContentDialog;
